// Utility to look for equality across question models. At times we need to know if
// an added question is the same as a survey question in a different collection, for example.
const equals = (q1: any, q2: any): boolean => {
	let isEqual = sameSurveyQuestionId(q1, q2);
	if (isEqual !== undefined) {
		return isEqual;
	}
	isEqual = sameQuestionVariationId(q1, q2);
	if (isEqual !== undefined) {
		return isEqual;
	}
	if (sameQuestionId(q1, q2)) {
		return true;
	}
	// Last resort: not always reliable because questions with the same text on the
	// same survey is a legitimate use case. But in some cases, this is all we have in
	// common to compare. Will need additional work to eliminate the need for this.
	if (sameText(q1, q2)) {
		return true;
	}
	return false;
};

const sameSurveyQuestionId = (q1: any, q2: any): boolean | undefined => {
	if (q1.surveyQuestionId && q2.surveyQuestionId && q1.surveyQuestionId === q2.surveyQuestionId) {
		return true;
	} else if (q1.surveyQuestionId && q2.surveyQuestionId && q1.surveyQuestionId !== q2.surveyQuestionId) {
		return false;
	}
	return undefined;
};

const sameQuestionVariationId = (q1: any, q2: any): boolean | undefined => {
	const q1Variation = q1.questionVariationId || q1.sourceQuestionVariationId || undefined;
	const q2Variation = q2.questionVariationId || q2.sourceQuestionVariationId || undefined;
	if (q1Variation && q2Variation && q1Variation === q2Variation) {
		return true;
	} else if (q1Variation && q2Variation && q1Variation !== q2Variation) {
		return false;
	}
	return undefined;
};

// It seems that questionId is overloaded at times, so we look for equality across
// questionId and surveyQuestionId if necessary.
const sameQuestionId = (q1: any, q2: any): boolean => {
	if (q1.questionId && q2.questionId && q1.questionId === q2.questionId) {
		return true;
	} else if (q1.questionId && q2.surveyQuestionId && q1.questionId === q2.surveyQuestionId) {
		return true;
	} else if (q1.surveyQuestionId && q2.questionId && q1.surveyQuestionId === q2.questionId) {
		return true;
	}
	return false;
};

const sameText = (q1: any, q2: any): boolean => {
	if (q1.text && q2.text && q1.text === q2.text) {
		return true;
	}
	return false;
};

export const QuestionEqualityHelper = {
	equals,
};
